import { ComponentStyleConfig } from "@chakra-ui/react";
import { fieldStyle } from "./input";

export const ReiSelect: ComponentStyleConfig = {
  variants: {
    outline: {
      field: fieldStyle,
      icon: { color: "ink.muted" },
    },
  },
  defaultProps: {
    variant: "outline",
  },
};
